var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import { Card as MuiCard } from '@mui/material';
import { SelectIcon, CardContext, ChipContainer } from './utils';
/**
 * Pigment [Card](https://pigment.customink.com/?path=/docs/components-card)
 */
var Card = React.forwardRef(function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.selected, selected = _c === void 0 ? false : _c, _d = _a.selectable, selectable = _d === void 0 ? false : _d, onSelect = _a.onSelect, chip = _a.chip, children = _a.children, sx = _a.sx, props = __rest(_a, ["size", "selected", "selectable", "onSelect", "chip", "children", "sx"]);
    var blue = designTokens.color.blue.default.value;
    return (React.createElement(MuiCard, __assign({ ref: ref, sx: __assign(__assign({ '> div:last-of-type': {
                paddingBottom: size === 'medium' ? '24px' : '16px',
            } }, (selectable && selected
            ? {
                border: "1px solid ".concat(blue),
                '&:hover': {
                    border: "1px solid ".concat(blue),
                },
            }
            : {})), sx) }, props),
        React.createElement(CardContext.Provider, { value: size },
            children,
            !!chip && React.createElement(ChipContainer, null, chip),
            selectable ? (React.createElement(SelectIcon, { selected: selected, onSelect: onSelect })) : null)));
});
export default Card;
//# sourceMappingURL=Card.js.map